var _g, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAppraisals = function SvgAppraisals(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.831381, 0, 0, 0.898376, 3.541, 2.032477)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 18.92 5.01 C 18.72 4.42 18.16 4 17.5 4 L 6.5 4 C 5.84 4 5.29 4.42 5.08 5.01 L 3 11 L 3 19 C 3 19.55 3.45 20 4 20 L 5 20 C 5.55 20 6 19.55 6 19 L 6 18 L 18 18 L 18 19 C 18 19.55 18.45 20 19 20 L 20 20 C 20.55 20 21 19.55 21 19 L 21 11 L 18.92 5.01 Z M 6.85 6 L 17.14 6 L 18.18 9 L 5.81 9 L 6.85 6 L 6.85 6 Z M 19 16 L 5 16 L 5 11.34 L 5.12 11 L 18.89 11 L 19 11.34 L 19 16 Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 13.5,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 13.5,
    r: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 4.889 0.199 C 2.299 0.199 0.198 2.259 0.198 4.796 C 0.198 7.334 2.299 9.394 4.889 9.394 C 7.475 9.394 9.576 7.334 9.576 4.796 C 9.576 2.259 7.475 0.199 4.889 0.199 Z M 5.55 7.597 L 5.55 8.475 L 4.296 8.475 L 4.296 7.588 C 3.495 7.422 2.815 6.915 2.762 6.023 L 3.682 6.023 C 3.729 6.506 4.067 6.884 4.925 6.884 C 5.845 6.884 6.051 6.434 6.051 6.153 C 6.051 5.771 5.845 5.412 4.799 5.17 C 3.635 4.894 2.838 4.424 2.838 3.48 C 2.838 2.691 3.489 2.175 4.296 2.006 L 4.296 1.117 L 5.55 1.117 L 5.55 2.014 C 6.421 2.221 6.856 2.87 6.886 3.574 L 5.967 3.574 C 5.943 3.064 5.666 2.713 4.925 2.713 C 4.222 2.713 3.8 3.027 3.8 3.469 C 3.8 3.855 4.104 4.107 5.051 4.346 C 5.999 4.585 7.012 4.984 7.012 6.144 C 7.007 6.985 6.365 7.444 5.55 7.597 Z",
    style: {}
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppraisals, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appraisals.69ed1823.svg";
export { ForwardRef as ReactComponent };